import { useState, useEffect, useRef } from "react";
import { uploadNewsLetter } from "../../../service/api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function Footer() {
  const [btnloading, setBtnLoading] = useState(false);
      const newsLetterSubmit = async (e) => {
        e.preventDefault();
        try {
          setBtnLoading(true);
    
          const form = e.target;
          const data = {
            email: form.email.value,
          };
    
          const response = await uploadNewsLetter(data);
    
          toast.success(response.data.message);
    
          form.reset();
        } catch (error) {
          // Check if the error is from the server
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            toast.error(error.response.data.message);
          } else {
            // Fallback to generic error message
            toast.error(error.message || "Something went wrong");
          }
        } finally {
          setBtnLoading(false);
        }
      };
  return (
    <footer className="footer-wrp-main position-relative wow animate__fadeIn overflow-hidden">
      <div className="area">
        <ul className="circles">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
      <div className="footerMain">
        <div className="site-width">
          <div className="footerNewsletter">
            <div className="row align-item-center">
              <div className="col-md-6">
                <div className="titleSection light">
                  <h2>Our Newsletter</h2>
                  <p>
                    Subscribe to our newsletter — work smarter, hire faster,
                    stay ahead.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="newsLetterInput">
                  <form onSubmit={newsLetterSubmit}>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter Your Email Here"
                    />
                      <button
                        type="submit"
                        disabled={btnloading}
                      >
                        {btnloading ? (
                          <span>
                            <i
                              className="fa fa-spinner fa-spin"
                              style={{ marginRight: "8px" }}
                            ></i>
                            Submitting...
                          </span>
                        ) : (
                          "Submit Now"
                        )}
                      </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-links-wrp">
            <div className="row">
              <div className="col-md-3">
                <div className="footer-logo-wrp position-relative">
                  <a href="/">
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/img/logo-light.svg`}
                      className="img-fluid"
                      alt=""
                    />
                  </a>
                </div>
                <div className="footerContents">
                  <ul className="footerSocial">
                    <li>
                      <a href="javascript:void(0)" target="_blank">
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" target="_blank">
                        <i className="fa-brands fa-x-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" target="_blank">
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" target="_blank">
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col">
                <div className="ftr-link-bx">
                  <p className="ttle mb-2">
                    <a href="javascript:void(0)" className="title-16">
                      Usefull Links
                    </a>
                  </p>
                  <a href="/about">
                    <i className="fa-solid fa-chevron-right"></i> About Us
                  </a>
                  <a href="/contact-us">
                    <i className="fa-solid fa-chevron-right"></i> Contact Us
                  </a>
                  <a href="/employer/home">
                    <i className="fa-solid fa-chevron-right"></i> Employer Home
                  </a>
                  <a href="/data-processing-agreement">
                    <i className="fa-solid fa-chevron-right"></i> Data
                    Processing
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="ftr-link-bx">
                  <p className="ttle mb-2">
                    <a href="javascript:void(0)" className="title-16">
                      Help Center
                    </a>
                  </p>
                  <a href="/user-service-agreement">
                    <i className="fa-solid fa-chevron-right"></i> User Service
                  </a>
                  <a href="/privacy-policy">
                    <i className="fa-solid fa-chevron-right"></i> Privacy Policy
                  </a>
                  <a href="/terms-and-condition">
                    <i className="fa-solid fa-chevron-right"></i> Terms &
                    Conditions
                  </a>
                  <a href="/payment-refund">
                    <i className="fa-solid fa-chevron-right"></i> Payment &
                    Refund
                  </a>
                  <a href="/cookie-policy">
                    <i className="fa-solid fa-chevron-right"></i> Cookie Policy
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="ftr-link-bx">
                  <p className="ttle mb-2">
                    <a href="javascript:void(0)" className="title-16">
                      Login Section
                    </a>
                  </p>
                  <a href="/jobseeker/login">
                    <i className="fa-solid fa-chevron-right"></i> User Login
                  </a>
                  <a href="/employer/login">
                    <i className="fa-solid fa-chevron-right"></i> Employer Login
                  </a>
                </div>
              </div>
              <div className="col">
                <div className="appDownload ftr-link-bx">
                  <p className="ttle mb-2">
                    <a href="javascript:void(0)" className="title-16">
                      Get our App
                    </a>
                  </p>
                  <p>Get real-time job updates on our App</p>
                  <div className="appdownloadfooterbtns">
                    <a href="javascript:void(0)">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/other/GplayOneThemeHd.png`}
                        alt="img"
                      />
                    </a>
                    <a href="javascript:void(0)">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/img/other/AppstoreOneThemeHd.png`}
                        alt="img"
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-btm-wrp">
        <div className="site-width">
          <div className="footer-btm-bx">
            <div className="row">
              <div className="col-md-12 col-lg-12 ">
                <p className="copy-txt text-center ">
                  Copyright ©{" "}
                  <script> &copy; {new Date().getFullYear()}</script>{" "}
                  <span style={{ color: "#eb642d" }}>Hourlee</span> | All Rights
                  Reserved
                </p>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
